<main class="voltage-dashboard" dir="rtl" [attr.aria-busy]="loading">
  <div class="dashboard-shell table-page">
    <header class="header dashboard-header">
      <div class="title-row">
        <button type="button" class="back" aria-label="بازگشت" title="بازگشت" (click)="goBack()">
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
        <h1 class="title">داشبورد عملکرد خودرو</h1>
        <div class="actions" *ngIf="strDate">
          <div class="dashboard-date">
            <i class="fa fa-calendar" aria-hidden="true"></i>
            <span>تاریخ گزارش</span>
            <time dir="ltr">{{ strDate | faNum }}</time>
          </div>
        </div>
      </div>
    </header>

    <section *ngIf="loading" class="card dashboard-loading" role="status" aria-live="polite">
      <div class="loader show">
        <div class="spinner" aria-hidden="true"></div>
        <span>در حال دریافت اطلاعات داشبورد...</span>
      </div>
    </section>

    <ng-container *ngIf="!loading">
      <app-voltage-speed-kpis [summary]="dashboard?.Table?.[0] || null" [loading]="loading"></app-voltage-speed-kpis>

      <section class="dashboard-row dashboard-row--primary" aria-label="تحلیل حرکت و وضعیت موتور">
        <article class="dashboard-panel" aria-label="نمودار هم‌زمان سرعت و ولتاژ">
          <app-voltage-speed-timeline [samples]="dashboard?.Table1 || []"></app-voltage-speed-timeline>
        </article>
        <article class="dashboard-panel" aria-label="تحلیل وضعیت موتور">
          <app-voltage-speed-engine-state [summary]="dashboard?.Table?.[0] || null"></app-voltage-speed-engine-state>
        </article>
      </section>

      <section class="dashboard-row dashboard-row--profile" aria-label="تحلیل الگوی ولتاژ">
        <article class="dashboard-panel" aria-label="رابطه سرعت و ولتاژ">
          <app-voltage-speed-scatter [samples]="dashboard?.Table1 || []"></app-voltage-speed-scatter>
        </article>
        <article class="dashboard-panel" aria-label="پروفایل ولتاژ خودرو">
          <app-voltage-speed-profile [summary]="dashboard?.Table?.[0] || null" [samples]="dashboard?.Table1 || []"></app-voltage-speed-profile>
        </article>
      </section>

      <section class="dashboard-kpis dashboard-kpis--advanced" aria-label="شاخص‌های تکمیلی تحلیل">
        <article class="dashboard-card" aria-label="همبستگی کل روز">
          <app-voltage-speed-correlation [samples]="dashboard?.Table1 || []" title="همبستگی کل روز" description="ارتباط آماری سرعت و ولتاژ"></app-voltage-speed-correlation>
        </article>
        <article class="dashboard-card" aria-label="همبستگی حین حرکت">
          <app-voltage-speed-correlation [samples]="dashboard?.Table1 || []" [movingOnly]="true" title="همبستگی حین حرکت" description="نمونه‌های در حال حرکت"></app-voltage-speed-correlation>
        </article>
        <article class="dashboard-card" aria-label="پوشش زمانی معتبر">
          <app-voltage-speed-summary-kpi [value]="dashboard?.Table8?.[0]?.CoveragePercent" [percentage]="true" title="پوشش زمانی معتبر" description="درصد پوشش زمانی گزارش‌شده"></app-voltage-speed-summary-kpi>
        </article>
        <article class="dashboard-card" aria-label="رویدادهای ولتاژ">
          <app-voltage-speed-summary-kpi [value]="dashboard?.Table10?.[0]?.EpisodeCount" title="رویدادهای ولتاژ" description="مجموع رویدادهای شناسایی‌شده"></app-voltage-speed-summary-kpi>
        </article>
      </section>

      <section class="dashboard-row dashboard-row--quality" aria-label="ارزیابی شارژ و کیفیت داده‌ها">
        <article class="dashboard-panel" aria-label="پایداری سیستم شارژ">
          <app-voltage-speed-charging-stability [assessment]="dashboard?.Table10?.[0] || null" [samples]="dashboard?.Table1 || []"></app-voltage-speed-charging-stability>
        </article>
        <article class="dashboard-panel" aria-label="کیفیت و پوشش زمانی داده‌ها">
          <app-voltage-speed-data-quality [quality]="dashboard?.Table8?.[0] || null"></app-voltage-speed-data-quality>
        </article>
      </section>

      <section class="dashboard-row dashboard-row--anomalies" aria-label="نوسانات ولتاژ و الگوی تاریخی">
        <article class="dashboard-panel" aria-label="نوسانات غیرعادی ولتاژ">
          <app-voltage-speed-anomalies [episodes]="dashboard?.Table9 || []"></app-voltage-speed-anomalies>
        </article>
        <article class="dashboard-panel" aria-label="الگوی تاریخی خودرو">
          <app-voltage-speed-historical-baseline [baselines]="dashboard?.Table6 || []" [states]="dashboard?.Table3 || []"></app-voltage-speed-historical-baseline>
        </article>
      </section>

      <section class="dashboard-panel dashboard-insights" aria-label="بینش‌های تحلیلی روز">
        <app-voltage-speed-daily-insights [summary]="dashboard?.Table?.[0] || null" [samples]="dashboard?.Table1 || []" [assessment]="dashboard?.Table10?.[0] || null"></app-voltage-speed-daily-insights>
      </section>
      <section class="dashboard-panel dashboard-events" aria-label="رویدادهای مهم روز">
        <app-voltage-speed-daily-events [samples]="dashboard?.Table1 || []" [changes]="dashboard?.Table4 || []"></app-voltage-speed-daily-events>
      </section>
    </ng-container>
  </div>
</main>
